export const SplitDaysToPolicy = ({

    ITEM_SHIP_CONS_FOR: "Shipper/Consignee/Forwarder",
    ITEM_OWNER: "Owner",

})